import { __assign, __rest } from "tslib";
import React from 'react';
import { Input } from '@chakra-ui/react';
import PopoverComponent from '../PopOver';
var DateComponentWrapper = function (_a) {
    var value = _a.value, children = _a.children, isDisabled = _a.isDisabled, props = __rest(_a, ["value", "children", "isDisabled"]);
    return (React.createElement(PopoverComponent, __assign({ target: React.createElement(Input, __assign({ readOnly: true, cursor: 'pointer', borderColor: 'primary', name: 'date-picker-input', bg: 'background.default' }, { value: value, isDisabled: isDisabled })), contentProps: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minW: 400,
            minH: 450
        } }, props), children));
};
export default DateComponentWrapper;
//# sourceMappingURL=DateComponentWrapper.js.map